import { Component } from '@theme/component';

/**
 * Scroll-forward chevron for the collection quick links list.
 * Hides itself when the list doesn't overflow or is scrolled to the end.
 *
 * @typedef {object} Refs
 * @property {HTMLElement} list - The scrollable quick links list.
 * @property {HTMLButtonElement} scrollButton - The scroll-forward button.
 *
 * @extends Component<Refs>
 */
class CollectionQuickLinks extends Component {
  requiredRefs = ['list', 'scrollButton'];

  #abortController = new AbortController();

  connectedCallback() {
    super.connectedCallback();

    const { signal } = this.#abortController;
    this.refs.list.addEventListener('scroll', this.#update, { signal, passive: true });
    window.addEventListener('resize', this.#update, { signal });
    this.#update();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#abortController.abort();
  }

  scrollForward() {
    const { list } = this.refs;
    list.scrollBy({ left: list.clientWidth * 0.8, behavior: 'smooth' });
  }

  #update = () => {
    const { list, scrollButton } = this.refs;
    const maxScroll = list.scrollWidth - list.clientWidth;
    scrollButton.hidden = maxScroll <= 1 || list.scrollLeft >= maxScroll - 1;
  };
}

if (!customElements.get('collection-quick-links')) {
  customElements.define('collection-quick-links', CollectionQuickLinks);
}
